import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Alert
} from 'reactstrap';
import LabelInput from '@src/components/LabelInput/LabelInput';
import { maxLength } from '@src/validation';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';

const fieldValidator = {
  loan_number_1: [value => maxLength(value, 64)],
  first_mortgage_clause: [],
  loan_number_2: [value => maxLength(value, 64)],
  second_mortgage_clause: [],
  loan_number_3: [value => maxLength(value, 64)],
  third_mortgage_clause: [],
  escrow_number: [value => maxLength(value, 128)],
  is_cognito: []
};

class CognitoMortgagesModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};

    Object.keys(fieldValidator).forEach(key => {
      fields[key] = {
        value: props.entity[key] !== null ? props.entity[key] : '',
        visited: false,
        error: false
      };
    });
    fields.first_mortgage_clause.value =
      props.entity.evidence_of_insurance_form.first_mortgage_clause;
    fields.second_mortgage_clause.value =
      props.entity.evidence_of_insurance_form.second_mortgage_clause;
    fields.third_mortgage_clause.value =
      props.entity.evidence_of_insurance_form.third_mortgage_clause;

    fields['is_cognito'] = {
      value: 1,
      visited: false,
      error: false
    };

    this.state = {
      ...fields
    };
  }

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event === null
          ? ''
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  updateNewForm = (event, name, lenderType) => {
    const formData = JSON.parse(JSON.stringify(this.state[lenderType]));

    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event === null
          ? ''
          : event,
      visited: true,
      error: false
    };

    formData[name] = inputData;
    this.setState({
      [lenderType]: formData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = JSON.parse(JSON.stringify(this.state));
    const postData = {};
    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        formData[key].value.value !== undefined
          ? formData[key].value.value
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });

    this.setState({ ...formData });

    if (isValid) {
      this.props.onSubmit(postData, null);
    }
    return false;
  };

  render = () => {
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
        size={'lg'}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>
            {'Edit Mortgages / Additional Interest'}
          </ModalHeader>
          <div className={'position-relative'}>
            {this.props.loading && <ProgressBox text={'Submiting ...'} />}
            <ModalBody className={'p-4'}>
              {this.props.errorUnit && (
                <Alert color={'danger'}>{this.props.errorUnit}</Alert>
              )}
              <Row>
                <Col xs={12}>
                  <LabelInput
                    name={'Escrow #'}
                    type={'text'}
                    {...this.state.escrow_number}
                    onChange={event => this.updateForm(event, 'escrow_number')}
                  />
                </Col>
                <Col xs={12}>
                  <LabelInput
                    name={'1st Loan #'}
                    type={'text'}
                    {...this.state.loan_number_1}
                    onChange={event => this.updateForm(event, 'loan_number_1')}
                  />
                  <LabelInput
                    name={'Lender'}
                    type={'textarea'}
                    {...this.state.first_mortgage_clause}
                    style={{
                      lineHeight: '18px',
                      resize: 'none',
                      height: '100px'
                    }}
                    onChange={event =>
                      this.updateForm(event, 'first_mortgage_clause')
                    }
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                <Col xs={12}>
                  <LabelInput
                    name={'2nd Loan #'}
                    type={'text'}
                    {...this.state.loan_number_2}
                    onChange={event => this.updateForm(event, 'loan_number_2')}
                  />
                  <LabelInput
                    name={'Lender'}
                    type={'textarea'}
                    {...this.state.second_mortgage_clause}
                    style={{
                      lineHeight: '18px',
                      resize: 'none',
                      height: '100px'
                    }}
                    onChange={event =>
                      this.updateForm(event, 'second_mortgage_clause')
                    }
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                <Col xs={12}>
                  <LabelInput
                    name={'3rd Loan #'}
                    type={'text'}
                    {...this.state.loan_number_3}
                    onChange={event => this.updateForm(event, 'loan_number_3')}
                  />
                  <LabelInput
                    name={'Lender'}
                    type={'textarea'}
                    {...this.state.third_mortgage_clause}
                    style={{
                      lineHeight: '18px',
                      resize: 'none',
                      height: '100px'
                    }}
                    onChange={event =>
                      this.updateForm(event, 'third_mortgage_clause')
                    }
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4'}>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Save
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default CognitoMortgagesModal;
